import React from 'react';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';
import { Button } from 'reactstrap';
import { FaTrash } from 'react-icons/fa';
import { DELETE_DEPARTMENTAL_NUMBER } from '../queries';
import { showConfirmation } from '../ConfirmationDialogService';
import { displaySuccess, displayError, logAmplitudeEvent } from '../utilities';

const getMessage = department => (
  <>
    <span>
      Permanently delete the departmental number of{' '}
      <strong style={{ color: 'red' }}>{department}</strong>
      ?<br />
      <br />
      <strong>THIS PROCESS IS IRREVERSIBLE!</strong>
      <br />
      <small>PLEASE CONFIRM BEFORE PROCEEDING</small>
    </span>
  </>
);

const DeleteDepartmentalNumbers = ({
  department,
  departmentalNumbersId,
  isDisabled
}) => {
  const confirm = deleteDepartmentalNumbers => {
    showConfirmation(
      'Delete Departmental Numbers?',
      getMessage(department),
      () =>
        deleteDepartmentalNumbers({ variables: { id: departmentalNumbersId } })
    );
  };

  return (
    <Mutation
      mutation={DELETE_DEPARTMENTAL_NUMBER}
      onCompleted={() => {
        displaySuccess(`${department} has been deleted`);
        logAmplitudeEvent(
          'User_deleted',
          {
            deletedId: `${departmentalNumbersId}`,
            deletedDepartment: `${department}`
          },
          true
        );
      }}
      onError={e => displayError(e)}
      refetchQueries={() => ['GET_DEPARTMENTAL_NUMBERS']}
    >
      {(deleteDepartmentalNumbers, { loading }) => {
        return (
          <Button
            disabled={loading || isDisabled}
            color="link"
            onClick={() => confirm(deleteDepartmentalNumbers)}
          >
            <FaTrash />
          </Button>
        );
      }}
    </Mutation>
  );
};

DeleteDepartmentalNumbers.propTypes = {
  department: PropTypes.string.isRequired,
  departmentalNumbersId: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired
};

export default DeleteDepartmentalNumbers;
